module.exports = __webpack_public_path__ + "static/media/prodotti.2a5b6efe.svg";